module.exports = __webpack_public_path__ + "static/tariff-card-31589ffa4b44da6bfd89e77ebb13e093.jpg";